<template>
  <v-container fluid class="pa-0 mo-bg" style="min-height: 87vh">
    <v-row class="ma-0 pa-0" align="center" justify="center">
      <v-col cols="12" sm="10" md="8" lg="7">
        <v-sheet
          class="mo-panel neo-surface elevation-3 rounded-xl mx-auto"
          max-width="820"
        >
          <v-toolbar flat dense class="mo-toolbar">
            <v-btn icon small class="white--text mr-1" @click="onScanOtherMemo">
              <v-icon color="white" small>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text d-flex align-center">
              <v-icon left color="white" class="mr-2">mdi-factory</v-icon>
              Detail MEMO
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              small
              class="white--text"
              :disabled="loading"
              @click="refreshData"
            >
              <v-icon color="white" small :class="{ spin: loading }"
                >mdi-refresh</v-icon
              >
            </v-btn>
          </v-toolbar>
          <div class="position-relative">
            <canvas ref="bgCanvas" class="bg-canvas"></canvas>
            <div class="pa-6 neo-surface">
              <v-skeleton-loader
                v-if="loading"
                type="article, table, actions"
              />
              <div v-else>
                <v-row dense>
                  <v-col cols="12">
                    <div class="mo-header value emphasis-1">
                      {{ memo.no_memo }}
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">NO SO</div>
                    <div class="value">{{ memo.no_so }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">Tgl. Order</div>
                    <div class="value">
                      {{ memo.order_date }}
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">PLANT</div>
                    <div class="value">{{ memo.plant }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">CUSTOMER</div>
                    <div class="value">{{ memo.customer }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">NO POLISI</div>
                    <div class="value">{{ memo.no_polisi }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">JENIS MOBIL</div>
                    <div class="value">{{ memo.jenis_mobil }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-btn block disabled class="neo-btn"
                      >KLIK SKU UNTUK INPUT JML MUAT</v-btn
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-simple-table dense class="summary-table">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">No.</th>
                            <th class="text-left">Produk</th>
                            <th class="text-right">Qty</th>
                            <th class="text-right">Jml Muat</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(r, i) in memo.items"
                            :key="'m-' + i"
                            @click="confirmNext(r)"
                          >
                            <td>{{ i + 1 }}</td>
                            <td>{{ r.nama }}</td>
                            <td class="text-right">
                              {{ formatNumber(r.qty) }} {{ r.uom }}
                            </td>
                            <td class="text-right">
                              {{ formatNumber(r.loaded_qty) }} {{ r.uom }}
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td class="text-right strong">TOTAL AMDK</td>
                            <td class="text-right strong">
                              {{ formatNumber(totalAmdk) }}
                            </td>
                            <td class="text-right strong">
                              {{ formatNumber(totalLoadAmdk) }}
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td class="text-right strong">TOTAL KARTON</td>
                            <td class="text-right strong">
                              {{ formatNumber(totalKarton) }}
                            </td>
                            <td class="text-right strong">
                              {{ formatNumber(totalLoadKarton) }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <v-row class="mt-4" dense>
                  <v-col cols="12" md="6">
                    <v-btn block class="neo-btn" @click="onScanOtherMemo"
                      >KEMBALI</v-btn
                    >
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- Input jumlah muat -->
    <v-dialog v-model="dialogInputQty" max-width="420" persistent>
      <v-card class="neo-surface pa-4">
        <div class="page-title mb-2">Masukkan Jumlah Muatan</div>
        <v-text-field
          class="neo-input"
          label="Masukkan jumlah"
          type="number"
          min="0"
          v-model.number="inputQty"
          dense
          outlined
        />
        <div class="dialog-actions">
          <v-btn class="neo-btn save-btn" block @click="saveQty">
            SIMPAN
          </v-btn>
          <v-btn class="neo-btn cancel-btn" block @click="cancelQty">
            BATAL
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Notif sukses simpan -->
    <v-dialog v-model="dialogSaved" max-width="420">
      <v-card class="neo-surface pa-5 text-center">
        <v-icon color="#43A047" large>mdi-check-circle</v-icon>
        <div class="mt-2 strong">Data berhasil disimpan.</div>
        <div class="mt-3">
          <v-btn class="neo-btn" @click="onScanOtherMemo">MEMO LAIN</v-btn>
          <v-btn class="neo-btn" @click="gotoDashboard">SELESAI</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Notif warning -->
    <v-dialog v-model="dialogWarning" max-width="380">
      <v-card class="neo-surface pa-5 text-center">
        <v-icon class="warning-icon" large>mdi-alert-circle</v-icon>
        <div class="mt-3 strong">
          {{ warningMessage || 'Jumlah muatan minimal 1.' }}
        </div>
        <div class="mt-4">
          <v-btn class="neo-btn" @click="dialogWarning = false">MENGERTI</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Notif selesai -->
    <v-dialog v-model="dialogFinish" max-width="420">
      <v-card class="neo-surface pa-5 text-center">
        <v-icon color="#43A047" large>mdi-check-circle</v-icon>
        <div class="mt-2 strong">
          Silahkan ambil form palet yang telah berhasil dicetak
        </div>
        <div class="mt-3">
          <v-btn class="neo-btn" @click="finishFlow">SELESAI</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import buildType from '../../../../services/buildType'
import { mapGetters, mapMutations } from 'vuex'

const createEmptyMemo = (memoNo = '') => ({
  id: '',
  no_memo: memoNo,
  no_so: '-',
  total_order: 0,
  plant: '-',
  company_name: '-',
  customer: '-',
  jenis_mobil: '-',
  no_polisi: '-',
  driver_name: '-',
  order_date: '-',
  items: [],
  rawItems: []
})

export default {
  name: 'MemoDetail',
  data() {
    return {
      passedApi: buildType.apiURL('passed'),
      loading: true,
      memo: createEmptyMemo(),
      dialogInputQty: false,
      inputIndex: -1,
      inputQty: null,
      dialogSaved: false,
      dialogWarning: false,
      warningMessage: '',
      dialogFinish: false,
      memoItemId: null
    }
  },
  computed: {
    ...mapGetters(['getMemoDetail', 'getPassetDetail']),
    totalMemo() {
      return (this.memo.items || []).reduce((a, b) => a + Number(b.qty || 0), 0)
    },
    totalAmdk() {
      const arr = this.memo.items || []
      return arr
        .filter((x) =>
          String(x.nama || '')
            .toLowerCase()
            .includes('amdk')
        )
        .reduce((a, b) => a + Number(b.qty || 0), 0)
    },
    totalLoadAmdk() {
      const arr = this.memo.items || []
      return arr
        .filter((x) =>
          String(x.nama || '')
            .toLowerCase()
            .includes('amdk')
        )
        .reduce((a, b) => a + Number(b.loaded_qty || 0), 0)
    },
    totalKarton() {
      const arr = this.memo.items || []
      return arr
        .filter((x) =>
          String(x.nama || '')
            .toLowerCase()
            .includes('karton')
        )
        .reduce((a, b) => a + Number(b.qty || 0), 0)
    },
    totalLoadKarton() {
      const arr = this.memo.items || []
      return arr
        .filter((x) =>
          String(x.nama || '')
            .toLowerCase()
            .includes('karton')
        )
        .reduce((a, b) => a + Number(b.loaded_qty || 0), 0)
    }
  },
  watch: {
    getMemoDetail() {
      this.initializeMemo()
    }
  },
  methods: {
    ...mapMutations(['setMemoDetail', 'setPassetDetail']),
    gotoDashboard() {
      this.setMemoDetail(null)
      this.setPassetDetail(null)
      const path = '/manufacture/lot-checker'
      if (this.$route.path !== path) this.$router.push(path)
    },
    onScanOtherMemo() {
      this.dialogSaved = false
      this.setMemoDetail(null)
      // Return to pallet detail page
      this.$router &&
        this.$router.push({
          name: 'lotCheckerSpreadPalletDetail',
          query: { no: this.getPassetDetail.passed_no }
        })
    },
    openInputQty(row, idx) {
      // not used via per-row button anymore, kept for flexibility
      this.inputIndex = idx
      this.inputQty = row && row.qty != null ? row.qty : 0
      this.dialogInputQty = true
    },
    saveQty() {
      console.log('memoDetail>>>', this.getMemoDetail)
      console.log('memoItemID>>>', this.memoItemId)
      console.log('passetDetail>>>', this.getPassetDetail)

      const v = Number(this.inputQty)
      if (!v || isNaN(v) || v < 1) {
        this.warningMessage = 'Masukkan jumlah muatan minimal 1.'
        this.dialogWarning = true
        return
      }
      // this.dialogInputQty = false
      // this.dialogSaved = true
      this.saveLoading()
    },
    async saveLoading() {
      this.loading = true

      try {
        const { data: payload } = await axios.post(
          `${this.passedApi}memo_pallet/load`,
          {
            memo_id: this.getMemoDetail.id,
            memo_loading_item_id: this.memoItemId,
            manufacturing_order_pallet_id: this.getPassetDetail.id,
            qty_loading: this.inputQty,
            user_id: 1,
            user_name: 'Administrator'
          }
        )

        const ok = payload?.status_code === '00' && payload?.data
        if (!ok) {
          const message = payload?.status_msg || 'Gagal update muatan'
          if (this.$swal) {
            this.$swal.fire('Info', message, 'warning')
          }
          return
        }

        if (this.$swal) {
          this.$swal.fire('Success', payload.status_msg, 'success')
        }
        // await this.initializeMemo()

        this.dialogSaved = true
      } catch (error) {
        console.error('saveLoading error', error)
        if (this.$swal) {
          this.$swal.fire('Error', 'Gagal update muatan', 'error')
        }
      } finally {
        this.inputQty = 0
        this.memoItemId = null
        this.dialogInputQty = false
        this.loading = false
      }
    },
    cancelQty() {
      this.inputQty = 0
      this.memoItemId = null
      this.dialogInputQty = false
    },
    confirmNext(item) {
      // open input jumlah muat first
      this.memoItemId = item && item.id != null ? item.id : null
      this.inputIndex = -1
      this.inputQty = 0
      this.dialogInputQty = true
    },
    finishFlow() {
      this.dialogFinish = false
      this.$router && this.$router.push({ name: 'lotChecker' })
    },
    drawBackground() {
      const c = this.$refs.bgCanvas
      if (!c) return
      const w = c.parentElement.clientWidth
      const h = 220
      c.width = w
      c.height = h
      const x = c.getContext('2d')
      x.clearRect(0, 0, w, h)
      const g1 = x.createRadialGradient(
        w * 0.25,
        h * 0.5,
        10,
        w * 0.25,
        h * 0.5,
        170
      )
      g1.addColorStop(0, 'rgba(144,202,249,.35)')
      g1.addColorStop(1, 'rgba(144,202,249,0)')
      x.fillStyle = g1
      x.beginPath()
      x.arc(w * 0.25, h * 0.55, 150, 0, Math.PI * 2)
      x.fill()
      const g2 = x.createRadialGradient(
        w * 0.8,
        h * 0.2,
        10,
        w * 0.8,
        h * 0.2,
        150
      )
      g2.addColorStop(0, 'rgba(165,214,167,.35)')
      g2.addColorStop(1, 'rgba(165,214,167,0)')
      x.fillStyle = g2
      x.beginPath()
      x.arc(w * 0.8, h * 0.25, 140, 0, Math.PI * 2)
      x.fill()
    },
    formatNumber: function (n) {
      if (n == null || isNaN(n)) return '0'
      try {
        return Number(n).toLocaleString('id-ID')
      } catch (e) {
        return String(n)
      }
    },
    initializeMemo() {
      this.loading = true
      const detail = this.getMemoDetail
      console.log('Initializing memo detail:', detail)

      if (!detail) {
        this.loading = false
        if (this.$router) this.$router.back()
        return
      }

      const items = this.transformMemoItems(detail.memo_items)
      const nextMemo = createEmptyMemo(detail.memo_no)
      nextMemo.no_so = detail.so_no || '-'
      nextMemo.company_name = detail.company_name || '-'
      nextMemo.plant = nextMemo.company_name
      nextMemo.customer = detail.customer_name || '-'
      nextMemo.jenis_mobil = detail.vehicle_model_name || '-'
      nextMemo.driver_name = detail.driver_name || '-'
      nextMemo.no_polisi = detail.license_plate_no || '-'
      nextMemo.order_date = this.formatDateTime(detail.order_date)
      nextMemo.items = items
      nextMemo.total_order = items.reduce(
        (total, item) => total + Number(item.qty || 0),
        0
      )
      nextMemo.rawItems = Array.isArray(detail.memo_items)
        ? detail.memo_items
        : []
      this.memo = nextMemo
      this.loading = false
    },
    refreshData() {
      this.initializeMemo()
    },
    transformMemoItems(list) {
      if (!Array.isArray(list)) return []
      return list.map((item) => ({
        id: item.id,
        nama: item.product_name || item.description || 'Produk',
        qty: Number(item.qty || 0),
        loaded_qty: Number(item.loaded_qty || 0),
        uom: item.uom_name || '-',
        productId: item.product_id != null ? String(item.product_id) : '',
        productCode: item.product_code || '',
        raw: item
      }))
    },
    formatDateTime(value) {
      if (!value) return '-'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return String(value)
      const pad = (num) => (num < 10 ? `0${num}` : String(num))
      return (
        `${pad(date.getDate())}-${pad(
          date.getMonth() + 1
        )}-${date.getFullYear()}` +
        ` ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
          date.getSeconds()
        )}`
      )
    }
  },
  mounted() {
    this.$nextTick(() => this.drawBackground())
    window.addEventListener('resize', this.drawBackground)
    this.initializeMemo()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawBackground)
  }
}
</script>

<style scoped>
.mo-header {
  text-align: center;
  position: relative;
  min-height: 28px;
  padding-top: 2px;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
  color: #37474f;
}
.mo-toolbar {
  background: linear-gradient(135deg, #90caf9 0%, #a5d6a7 100%);
}

.mo-bg {
  background: linear-gradient(180deg, #fafcff 0%, #ffffff 70%);
}
.mo-panel {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}
.bg-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 220px;
  pointer-events: none;
}
.neo-surface {
  --bg: #f3f6fb;
  background: var(--bg) !important;
}
.label {
  color: #6b7280;
  font-size: 0.85rem;
  margin-bottom: 2px;
}
.value {
  color: #263238;
}
.value.uppercase {
  text-transform: uppercase;
}
.value.strong {
  font-weight: 700;
}
.value.emphasis-1 {
  font-size: 1.25rem;
  font-weight: 700;
}
.value.emphasis-2 {
  font-size: 1.15rem;
  font-weight: 600;
}
.neo-btn.v-btn {
  --bg: #f3f6fb;
  --hi: rgba(255, 255, 255, 0.95);
  background: var(--bg) !important;
  color: #263238 !important;
  border-radius: 14px !important;
  padding: 10px 16px !important;
  text-transform: none;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.08), -8px -8px 16px var(--hi) !important;
}
.neo-btn.v-btn::before {
  background-color: transparent !important;
}
.summary-table thead th {
  background: linear-gradient(
    135deg,
    rgba(144, 202, 249, 0.25) 0%,
    rgba(165, 214, 167, 0.25) 100%
  );
  font-weight: 600;
  color: #37474f;
}
.summary-table td,
.summary-table th {
  border: 1px solid rgba(144, 202, 249, 0.25);
}

.neo-btn.save-btn {
  --bg: #e5f6eb;
  --hi: rgba(255, 255, 255, 0.95);
  color: #2e7d32 !important;
  border: 1px solid rgba(76, 175, 80, 0.2);
}

.neo-btn.cancel-btn {
  --bg: #fdeced;
  --hi: rgba(255, 255, 255, 0.95);
  color: #c62828 !important;
  border: 1px solid rgba(198, 40, 40, 0.2);
}

.dialog-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: 16px;
  margin-top: 24px;
}
.warning-icon {
  color: #f57c00;
}
</style>
